<template>
  <v-menu rounded offset-y px-0 min-width="150">
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="isEditable ? on : null"
        class="chip"
        :style="
          isEditable
            ? 'cursor: pointer !important;'
            : 'cursor: default !important;'
        "
        :small="!large"
        :data-testid="`statusChip-status-${entityStatus}`"
        :color="color"
      >
        <ValidationIndicator
          v-if="showValidationIcons"
          :isRevValidatedStatus="isEntityValidated"
          :isFinanciallyValidatedStatus="isEntityFinanciallyValidated"
          class="me-1"
        />
        <span class="caption" :class="textClass">{{ statusText }}</span>
        <v-icon v-if="isEditable" small :class="textClass"
          >mdi-chevron-down</v-icon
        >
      </v-chip>
    </template>
    <v-list nav dense class="mt-1 rounded">
      <v-list-item
        v-for="(statusItem, index) in availableStatus"
        link
        :class="{ 'selected-item': statusItem.value === entityStatus }"
        :data-testid="`statusChip-listItem-${statusItem.value}`"
        :key="index"
        @click="$emit('onChange', statusItem.value)"
      >
        <v-list-item-content class="py-0">
          <v-list-item-title class="blue-grey--text text--darken-2">{{
            statusItem.text
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import ValidationIndicator from '../Rev/ValidationIndicator.vue'

import revMixin from '@/mixins/revMixin'

import { utils } from 'frontend-js-shared'
import _ from 'lodash'

export default {
  name: 'StatusChip',

  mixins: [revMixin],

  props: {
    entity: { type: Object, required: false },

    status: {
      type: String,
      required: false,
    },

    availableStatus: {
      type: Array,
    },

    isEditable: {
      type: Boolean,
      default: false,
    },

    large: {
      type: Boolean,
      default: false,
    },

    showValidationIcons: {
      type: Boolean,
      default: false,
    },
  },

  components: { ValidationIndicator },

  computed: {
    isEntityValidated() {
      return this.isRevValidated(this.entity) ?? false
    },

    isEntityFinanciallyValidated() {
      return this.isFinanciallyValidated(this.entity) ?? false
    },

    entityStatus() {
      if (this.isChallengeEntity) return this.challengeStatus

      return this.status ?? this.entity?.status
    },

    isChallengeActive() {
      return utils.dates.isActiveDateRange(
        this.entity.startAt,
        this.entity.endAt
      )
    },

    isChallengeComingSoon() {
      return utils.dates.isEntityComingSoon(this.entity.startAt)
    },

    isChallengeEntity() {
      return (
        this.entity?.entityType === this.$constants.exploreEntityTypes.challenge
      )
    },

    challengeStatus() {
      if (!this.isChallengeEntity) return
      if (this.isChallengeActive) {
        return this.$constants.exploreEntityStatus.active
      }
      if (this.isChallengeComingSoon) {
        return this.$constants.exploreEntityStatus.soon
      }
      return this.$constants.exploreEntityStatus.closed
    },

    statusText() {
      const status = _.snakeCase(this.entityStatus)
      return this.$t(`common.entity_status.${status}`)
    },

    color() {
      return this.$constants.COLOR_BY_STATUS[this.entityStatus]
    },

    textClass() {
      return this.$constants.TEXT_COLOR_BY_STATUS[this.entityStatus]
    },
  },
}
</script>

<style lang="scss" scoped>
.chip:before {
  background-color: inherit !important;
}
.selected-item {
  background: $color-blue-lighten2;
  .v-list-item__title {
    color: $color-blue;
  }
}
</style>
